import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Input, Space } from "antd";

const TextFilter = (item, search, vague) => {
  const handleSearch = (selectedKeys, confirm, item) => {
    confirm();
    search({
      column_text: item.title,
      type: 'text',
      column_name: item.dataIndex,
      values: selectedKeys,
      column_type: vague ? 2 : 1
    })
  };

  const handleReset = (clearFilters) => {
    clearFilters();
  };

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys = [],
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      // onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          placeholder="请输入检索内容"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, item)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, item)}
            icon={<SearchOutlined />}
            style={{
              width: 90,
            }}
          >
            搜索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            style={{
              width: 90,
            }}
          >
            清空
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
  };
};
export default TextFilter;
